import { AbstractComponent } from "appworks/components/abstract-component";
import { Layers } from "appworks/graphics/layers/layers";
import { Timer } from "appworks/utils/timer";
import * as Logger from "js-logger";

export interface BannerComponentConfig {
    loopTime: number;
}

export class BannerComponent extends AbstractComponent {

    protected modeScenes: Map<string, string[]> = new Map<string, string[]>();

    protected mode: string;
    protected currentScene: number = 0;

    protected sceneTimeout: number;

    protected config: BannerComponentConfig = {
        loopTime: 20000
    };

    constructor(config?: Partial<BannerComponentConfig>) {
        super();

        if (config) {
            this.config = { ...this.config, ...config };
        }
    }
    public addScenesForMode(mode: string, scenes: string[]) {
        this.modeScenes.set(mode, scenes);
    }

    public start() {
        this.stop();
        this.sceneTimeout = Timer.setTimeout(() => this.nextScene(), this.config.loopTime);
    }

    public stop() {
        Timer.clearTimeout(this.sceneTimeout);
    }

    public setMode(mode: string) {
        const scenes = this.modeScenes.get(mode);

        if (!scenes) {
            Logger.warn("BannerComponent: Trying to show a mode which doesn't exist in config: " + mode);
            return;
        }

        if (Layers.get("Banners").hasScenes(scenes)) {
            this.mode = mode;
            this.currentScene = -1;

            this.nextScene();
        } else {
            throw new Error("Error: BannerComponent: Trying to show a mode which doesn't exist in the Banner layer.");
        }
    }

    public hide() {
        Layers.get("Banners").hide();
    }

    public show() {
        Layers.get("Banners").show();
    }

    protected nextScene() {
        const scenes = this.modeScenes.get(this.mode);

        if (scenes && scenes.length > 1) {
            this.currentScene++;
            if (this.currentScene >= scenes.length) {
                this.currentScene = 0;
            }

            Layers.get("Banners").setScene(scenes[this.currentScene]).execute();
        }

        this.start();
    }
}
